import React from 'react';
import { IResourceIcon, IResourceIconProps } from './ResourceIcon';

export const BrandportalIcon: IResourceIcon = React.forwardRef<SVGSVGElement, IResourceIconProps>((props, ref) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    ref={ref}
  >
    <path
      d="M45.5 1.75C46.4665 1.75 47.25 2.5335 47.25 3.5C47.25 4.4665 46.4665 5.25 45.5 5.25H17.5C14.6005 5.25 12.25 7.6005 12.25 10.5C12.25 13.3995 14.6005 15.75 17.5 15.75H47.25V54.25H15.75C11.884 54.25 8.75 51.116 8.75 47.25V10.5C8.75 5.66751 12.6675 1.75 17.5 1.75H45.5ZM12.25 47.25C12.25 49.183 13.817 50.75 15.75 50.75H17.5V19.25C15.6068 19.25 13.7646 18.6359 12.25 17.5V47.25ZM21 50.75H43.75V19.25H21V50.75ZM45.5 8.75C46.4665 8.75 47.25 9.5335 47.25 10.5C47.25 11.4665 46.4665 12.25 45.5 12.25H17.5C16.5335 12.25 15.75 11.4665 15.75 10.5C15.75 9.5335 16.5335 8.75 17.5 8.75H45.5Z"
      fill="white"
    />
    <mask
      id="mask0_brandportal"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="1"
      width="40"
      height="54"
    >
      <path
        d="M45.5 1.75C46.4665 1.75 47.25 2.5335 47.25 3.5C47.25 4.4665 46.4665 5.25 45.5 5.25H17.5C14.6005 5.25 12.25 7.6005 12.25 10.5C12.25 13.3995 14.6005 15.75 17.5 15.75H47.25V54.25H15.75C11.884 54.25 8.75 51.116 8.75 47.25V10.5C8.75 5.66751 12.6675 1.75 17.5 1.75H45.5ZM12.25 47.25C12.25 49.183 13.817 50.75 15.75 50.75H17.5V19.25C15.6068 19.25 13.7646 18.6359 12.25 17.5V47.25ZM21 50.75H43.75V19.25H21V50.75ZM45.5 8.75C46.4665 8.75 47.25 9.5335 47.25 10.5C47.25 11.4665 46.4665 12.25 45.5 12.25H17.5C16.5335 12.25 15.75 11.4665 15.75 10.5C15.75 9.5335 16.5335 8.75 17.5 8.75H45.5Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_brandportal)">
      <rect width="56" height="56" fill="white" />
    </g>
  </svg>
));

BrandportalIcon.displayName = 'BrandportalIcon';
